var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1971_30517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.74228e-07L0 20L20 20V0L0 8.74228e-07Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1971_30517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.04297 1.66406V6.66406C6.04297 7.00573 5.75964 7.28906 5.41797 7.28906C5.0763 7.28906 4.79297 7.00573 4.79297 6.66406V1.66406C4.79297 1.3224 5.0763 1.03906 5.41797 1.03906C5.75964 1.03906 6.04297 1.3224 6.04297 1.66406Z",
    fill: "#002857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.04297 14.9987V18.332C6.04297 18.6737 5.75964 18.957 5.41797 18.957C5.0763 18.957 4.79297 18.6737 4.79297 18.332V14.9987C4.79297 14.657 5.0763 14.3737 5.41797 14.3737C5.75964 14.3737 6.04297 14.657 6.04297 14.9987Z",
    fill: "#002857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.95833 11.6654C8.95833 13.6154 7.36667 15.207 5.41667 15.207C3.46667 15.207 1.875 13.6154 1.875 11.6654C1.875 9.71537 3.46667 8.1237 5.41667 8.1237C7.36667 8.1237 8.95833 9.71537 8.95833 11.6654ZM3.125 11.6654C3.125 12.932 4.15 13.957 5.41667 13.957C6.68333 13.957 7.70833 12.932 7.70833 11.6654C7.70833 10.3987 6.68333 9.3737 5.41667 9.3737C4.15 9.3737 3.125 10.3987 3.125 11.6654Z",
    fill: "#002857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.207 1.66667V5C15.207 5.34167 14.9237 5.625 14.582 5.625C14.2404 5.625 13.957 5.34167 13.957 5V1.66667C13.957 1.325 14.2404 1.04167 14.582 1.04167C14.9237 1.04167 15.207 1.325 15.207 1.66667Z",
    fill: "#002857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.207 13.332V18.332C15.207 18.6737 14.9237 18.957 14.582 18.957C14.2404 18.957 13.957 18.6737 13.957 18.332V13.332C13.957 12.9904 14.2404 12.707 14.582 12.707C14.9237 12.707 15.207 12.9904 15.207 13.332Z",
    fill: "#002857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1263 8.33333C18.1263 10.2833 16.5346 11.875 14.5846 11.875C12.6346 11.875 11.043 10.2833 11.043 8.33333C11.043 6.38333 12.6346 4.79167 14.5846 4.79167C16.5346 4.79167 18.1263 6.38333 18.1263 8.33333ZM12.293 8.33333C12.293 9.6 13.318 10.625 14.5846 10.625C15.8513 10.625 16.8763 9.6 16.8763 8.33333C16.8763 7.06667 15.8513 6.04167 14.5846 6.04167C13.318 6.04167 12.293 7.06667 12.293 8.33333Z",
    fill: "#002857"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.2ff695ddc3a0ee6093e2be97ea974c2d.svg";
export { ForwardRef as ReactComponent };